import './SiteUnitCommandsPopup.scoped.scss';
import useAlias from '@alias';
import Input from '@components/_elements/Input/Input';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Button } from '@mui/material';
import useGetDeviceControlLockMode from '@src/hooks/api/queries/controls-lock/useGetDeviceControlLockMode';
import storeConnector from '@store/storeConnector';
import { tsDueTimeMode } from '@utils/index_ts';

const ControlUnlockForm = ({
  deviceId,
  timeMode,
  siteMeta,
  setOverInput,
  controllerUnlockNotes,
  setControllerUnlockNotes,
  setControllerUnlockConfirm,
}) => {
  const alias = useAlias();
  const { data: controlLockModeRecord } = useGetDeviceControlLockMode(deviceId);

  const getCurrentTime = (ts) => {
    return tsDueTimeMode({
      timeMode,
      lat: siteMeta.GPSLat,
      long: siteMeta.GPSLong,
      ts,
    });
  };

  return (
    <div className='release-container'>
      <div className='loto-release-title'>
        <FormattedAlias id='Unlock Controller' />
      </div>
      <div className='loto-release-info'>
        <div>
          <FormattedAlias id='Lockout Start:' />
        </div>
        <div>
          {controlLockModeRecord?.createdAt
            ? getCurrentTime(controlLockModeRecord.createdAt)
            : ''}
        </div>
      </div>
      <div className='loto-release-info'>
        <div>
          <FormattedAlias id='Operator:' />
        </div>
        <div>{controlLockModeRecord?.updatedBy}</div>
      </div>
      <div className='loto-release-info'>
        <div>
          <FormattedAlias id='Notes:' />
        </div>
        <div>{controlLockModeRecord?.note}</div>
      </div>
      <div className='loto-release-info'>
        <div>
          <FormattedAlias id='Release Notes:' />
        </div>
        <Input
          type='text'
          onMouseEnter={() => setOverInput(true)}
          onMouseLeave={() => setOverInput(false)}
          onChange={(val) => setControllerUnlockNotes(val)}
          value={controllerUnlockNotes}
          placeholder={alias('Enter reason')}
        />
      </div>
      <div
        className='popup-row commands-popup-control'
        style={{ marginTop: '50px' }}
      >
        <Button
          disabled={!controllerUnlockNotes}
          onClick={() => setControllerUnlockConfirm(true)}
          variant='contained'
          color='error'
        >
          <FormattedAlias id='UNLOCK CONTROLLER' />
        </Button>
      </div>
    </div>
  );
};

export default storeConnector(ControlUnlockForm, {
  service: ['timeMode'],
  config: ['siteMeta'],
});
